export const landing5 = {
  hero: {
    title: "Automatizáld vállalkozásod, növeld bevételed",
    subtitle: "Weboldal, időpontfoglaló, marketing - minden automatikusan, AI segítségével. Több ügyfél, kevesebb adminisztráció.",
    cta: "Ingyenes visszahívást kérek",
    secondaryCta: "Nézd meg, hogyan működik",
  },
  proofPoints: {
    title: "Miért a Bespire?",
    items: [
      {
        value: "90%",
        label: "Időmegtakarítás",
        description: "Az adminisztrációra fordított idő csökkenése",
      },
      {
        value: "10 perc",
        label: "Beállítás",
        description: "Ennyi idő alatt elkészül a weboldal és foglalási rendszer",
      },
      {
        value: "0-24",
        label: "Elérhetőség",
        description: "Ügyfeleid bármikor foglalhatnak időpontot",
      },
    ],
  },
  featureTabs: {
    title: "Minden, amire szükséged van - egy helyen",
    subtitle: "Weboldal, foglalás, marketing - integráltan, nem szétszórtan",
    tabs: [
      {
        id: "website",
        title: "Weboldal építés",
        icon: "globe",
        headline: "Professzionális weboldal percek alatt",
        description: "Az AI asszisztens kérdéseket tesz fel, majd automatikusan épít neked egy professzionális weboldalt. Logó, színek, tartalom - minden a te márkádhoz igazodik.",
        features: [
          "Percek alatt kész az oldal",
          "Mobilbarát és modern design",
          "Saját domain használata",
          "Beépített értékesítési és fizetési rendszer",
        ],
      },
      {
        id: "booking",
        title: "Foglalási rendszer",
        icon: "calendar",
        headline: "Időpontfoglaló, ami tényleg működik",
        description: "Ügyfeleid 0-24 órában foglalhatnak időpontot, automatikus emlékeztetőket küldesz, és mindig látod a naptáradat egy helyen.",
        features: [
          "Egységes a weboldaladdal, nincs külsős rendszer",
          "Vendégek a weboldalon jelentkeznek be",
          "Több munkatárs kezelése",
          "Bérletek és tagságok automatikus kezelése",
        ],
      },
      {
        id: "marketing",
        title: "Marketing automatizálás",
        icon: "megaphone",
        headline: "Marketing, ami magától működik",
        description: "Az AI segít tartalmat készíteni, kampányokat futtatni és új ügyfeleket szerezni - marketing tudás nélkül.",
        features: [
          "AI-generált social média posztok",
          "Email marketing kampányok",
          "Ügyfél-visszahívó rendszer",
          "Elemzések és javaslatok",
        ],
      },
      {
        id: "payments",
        title: "Fizetés és számlázás",
        icon: "creditCard",
        headline: "Egyszerű és átlátható pénzügyek",
        description: "Online fizetés, helyszíni fizetés, számlázás - mindent egy helyen kezelhetsz. Automatikus számlakiállítás minden tranzakcióhoz.",
        features: [
          "Online bankkártyás fizetés",
          "Apple Pay és Google Pay",
          "Automatikus számlázás",
          "Helyszíni fizetés jutalék nélkül",
        ],
      },
      {
        id: "clients",
        title: "Ügyfélkezelés",
        icon: "users",
        headline: "Ismerd meg ügyfeleidet jobban",
        description: "Ügyfélkártyák, kezelési előzmények, preferenciák - minden egy helyen, hogy személyre szabott élményt nyújts.",
        features: [
          "Részletes ügyfélprofilok",
          "Kezelési előzmények nyilvántartása",
          "Címkézés és szegmentálás",
          "Hűségprogram kezelés",
        ],
      },
      {
        id: "analytics",
        title: "Statisztikák",
        icon: "barChart",
        headline: "Adatvezérelt döntések",
        description: "Részletes riportok a foglalásokról, bevételekről és ügyfélaktivitásról. Tudd, mi működik és mi nem.",
        features: [
          "Bevételi riportok és trendek",
          "Foglalási statisztikák",
          "Ügyfél-aktivitás elemzés",
          "Exportálható kimutatások",
        ],
      },
    ],
  },
  exclusiveFeatures: {
    title: "Mit értékesíthetsz a weboldaladon?",
    subtitle: "Több bevételi forrás, egy platformon - vállalkozásod növekedéséhez",
  },
  growthLevers: {
    title: "Növekedési eszközök",
    subtitle: "Extra funkciók, amik gyorsítják a fejlődésed",
    items: [
      {
        title: "AI Asszisztens",
        description: "Az AI kredit olyan, mint egy varázszseton: weboldal generálás, képek készítése, marketing tartalmak, üzleti javaslatok - mindet automatikusan. 100 ingyenes kreditet kapsz az induláshoz.",
        features: [
          "Weboldal generálás",
          "Marketing tartalmak készítése",
          "Képek generálása",
          "Üzleti javaslatok",
        ],
      },
      {
        title: "Gyors indulás",
        description: "Van már weboldalad? Az AI átnézi és átveszi a szövegeket, képeket, szolgáltatásokat. Nincs még semmid? Az AI kérdéseket tesz fel és nulláról épít neked mindent.",
        features: [
          "Meglévő weboldal importálása",
          "Kérdésalapú oldalépítés",
          "10 perc alatt kész",
          "Azonnal indulhat az értékesítés",
        ],
      },
    ],
  },
  testimonials: {
    title: "Amit ügyfeleink mondanak",
    subtitle: "Szolgáltatók, akik már használják a Bespire-t",
    items: [
      {
        name: "Nagy Éva",
        role: "Fodrász",
        location: "Budapest",
        text: "3 év után végre van egy professzionális weboldalám és nem kell egész nap a telefont nyomkodni foglalások miatt. A Bespire mindent automatizált.",
        rating: 5,
      },
      {
        name: "Kovács Márk",
        role: "Personal Trainer",
        location: "Debrecen",
        text: "Korábban 10-15 ügyfelem volt, most 40+ állandó kliensem van. Az online időpontfoglaló és a marketing AI csodát tett.",
        rating: 5,
      },
      {
        name: "Fitness Plus Stúdió",
        role: "Jóga és Pilates stúdió",
        location: "Szeged",
        text: "6 oktatóval dolgozunk és korábban káosz volt a naptár. Most minden szervezett, az ügyfelek elégedettek, mi pedig spóroljuk az időt.",
        rating: 5,
      },
      {
        name: "Tóth Réka",
        role: "Kozmetikus",
        location: "Győr",
        text: "Az automatikus emlékeztetők óta szinte nincs no-show. A bérletek kezelése is egyszerű, az ügyfeleim imádják az online foglalást.",
        rating: 5,
      },
      {
        name: "Szabó András",
        role: "Business Coach",
        location: "Pécs",
        text: "A marketing automatizálás hozta a legtöbb értéket. Az AI social media posztokat ír, én pedig az ügyfelekkel foglalkozom.",
        rating: 5,
      },
      {
        name: "Kiss Anna",
        role: "Masszőr",
        location: "Miskolc",
        text: "Egyedül dolgozom és a Bespire egy személyi asszisztenst jelent nekem. Foglalás, emlékeztetők, fizetés - minden automatikusan megy.",
        rating: 5,
      },
    ],
  },
  categoryLinks: {
    title: "Kinek való a Bespire?",
    subtitle: "Szolgáltatók széles körének segítünk a mindennapi munkában",
    viewAll: "Összes megtekintése",
  },
  newsletterCta: {
    title: "Készen állsz?",
    subtitle: "Iratkozz fel a várólistára és légy az elsők között, akik kipróbálják a Bespire-t.",
    cta: "Ingyenes visszahívást kérek",
  },
};
